import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useParams } from 'react-router-dom';

import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';

import NewsEditForm from './NewsEditForm';

function NewsEditPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [news, setNews] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/admin/news/${id}`).then(res => {
            setNews(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [id]);

    if (isLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A hír letöltése sikertelen." />;

    if (news)
        return (
            <>
                <h1>Hír szerkesztése</h1>
                <NewsEditForm news={news} />
            </>
        );

    return null;
}

export default NewsEditPage;
